import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.css',
  standalone: false,
})
export class ProgressBarComponent implements OnInit {
  public color = environment['colors']['primary'];
  public styleElement!: HTMLStyleElement;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const style = document.createElement('style');
      style.innerHTML = `.custom-progress-bar .mdc-linear-progress__bar-inner {
                            border-color: ${this.color} !important;
                          }
                          .custom-progress-bar .mdc-linear-progress__buffer-bar {
                            background-color: #80808042 !important;
                          }`;
      document.head.appendChild(style);
    }
  }
}
